import { getTriggerEventId } from './workflowTriggerUtils';

export function getPickerTriggerKey(trigger) {
  if (!trigger) return '';
  return trigger.eventKey || trigger.id || '';
}

export function isPickerTriggerSelected(trigger, activeTriggers = [], editingTriggerId = null) {
  if (!trigger) return false;
  const triggerKey = getPickerTriggerKey(trigger);

  if (editingTriggerId) {
    return activeTriggers.some((item) => (
      item.id === editingTriggerId
      && (
        item.id === trigger.id
        || getTriggerEventId(item) === triggerKey
      )
    ));
  }

  return activeTriggers.some((item) => (
    item.id === trigger.id
    || getTriggerEventId(item) === triggerKey
    || item.id === triggerKey
  ));
}
